import { TokenList } from "../store/global/getAllTokenLists";
import * as Sentry from "@sentry/browser";
import { Hash } from "viem";

export const getTokenIcon = (tokenAddress: Hash, tokenList: TokenList | undefined): string => {
  if (!tokenList) {
    Sentry.captureMessage(`Couldn't find token icon in local token icons ${tokenAddress}`);
    return "";
  }
  const iconUrl = tokenList[tokenAddress]?.iconUrl;
  if (iconUrl) {
    return iconUrl;
  } else {
    Sentry.captureMessage(
      `Couldn't find token icon in tokenList AND local token icons ${tokenAddress}`
    );
    return "";
  }
};
